var $15a34db8946b8ed1$exports = {};
$15a34db8946b8ed1$exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`
};


export {$15a34db8946b8ed1$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
